export var suggestionStrategy = function suggestionStrategy(contentBlock, callback) {
  var text = contentBlock.getText();
  return callback(0, text.length);
};